import { Intervention } from '@/app/components/action-plan/types';
import { getInterventionRiskData, sortInterventions } from '@/utils';
import { Box, Flex, Text } from '@cmpsr/components';
import React from 'react';
import ActiveInterventionCard from './components/active-intervention-card/active-intervention-card';

type CurrentActionPlanProps = {
  interventions: Intervention[];
  onCompleteIntervention: (intervention: Intervention) => void;
};

function CurrentActionPlan({ interventions, onCompleteIntervention }: CurrentActionPlanProps) {
  const sortedInterventions = interventions.map(getInterventionRiskData).sort(sortInterventions);

  return (
    <Box as="main" flexGrow={1}>
      <Text variant="text-header-M" mb={5}>
        Recommended Actions
      </Text>
      <Flex direction="column" gap="spacer-4">
        {sortedInterventions.map((intervention) => (
          <ActiveInterventionCard
            key={intervention.id}
            intervention={intervention}
            onCompleteIntervention={onCompleteIntervention}
          />
        ))}
      </Flex>
    </Box>
  );
}

export default React.memo(CurrentActionPlan);
